import { useMutation } from '@tanstack/react-query';

import { ReportingApi } from '@/API';
import { formatDate } from '@/utils';

import { DateRange } from './date-ranges';

type QuarterlyReviewApi = Pick<ReturnType<typeof ReportingApi>, 'generateQuarterlyReview'>;

export interface ExportQuarterlyReviewParams {
    globalAccountGUID: string;
    range: DateRange;
    selectedAccountGUIDs: string[];
    includeClosed: boolean;
}

// Exports the review the advisor is looking at: the on-screen date range, account selection and
// closed-account toggle scope the report's performance, chart, and activity sections.
const exportQuarterlyReview = async (
    { globalAccountGUID, range, selectedAccountGUIDs, includeClosed }: ExportQuarterlyReviewParams,
    api: QuarterlyReviewApi = ReportingApi(),
): Promise<void> => {
    const [, error] = await api.generateQuarterlyReview(globalAccountGUID, {
        fromInclusive: formatDate(range.fromInclusive, 'SERVER'),
        toInclusive: formatDate(range.toInclusive, 'SERVER'),
        groupByGuids: selectedAccountGUIDs.length ? selectedAccountGUIDs : undefined,
        // Only sent when on, so the live-only request stays exactly what it was before the flag.
        includeClosed: includeClosed || undefined,
    });
    if (error) {
        throw error;
    }
};

export const useExportQuarterlyReview = (params: ExportQuarterlyReviewParams) =>
    useMutation({ mutationFn: () => exportQuarterlyReview(params) });
